export default function reportPackagesDirective() {
  return {
    template: require('./report-packages.html'),
    controller: 'PRReportPackagesController',
    controllerAs: 'prReportPackagesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackages: '=',
    },
  };
}
